// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__ZKJRK","NavbarReserved":"Navbar_NavbarReserved__hNKiN"};